module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qrepr8-94e765759f65a9d4c32f5d3010d3ed93.jpg";